module.exports = __webpack_public_path__ + "static/media/jewelry-ring-classic.5aa61515.svg";